import { SHOP } from 'config/api-routes';
import { GET, PATCH } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

export default class ShopService {
  async getShop(slug: string, opts = {}) {
    const response = await GET(SHOP.ONE.GET(slug), opts);

    return formatResponse(response);
  }

  async updateShopSlug(shopId: number, slug: string, opts = {}) {
    const response = await PATCH(SHOP.SLUG.UPDATE.PATCH(shopId), { slug }, opts);

    return formatResponse(response);
  }

  async updateShop(shopId: number, data, opts = {}) {
    const response = await PATCH(SHOP.UPDATE.PATCH(shopId), data, opts);

    return formatResponse(response);
  }

  async searchShops(search: string, queryParams?, opts = {}) {
    const response = await GET(
      SHOP.SEARCH.GET({
        query: search,
        numberOfProducts: 3,
        ...queryParams,
      }),
      opts,
    );

    return formatResponse(response);
  }

  async getFeaturedShop(opts = {}) {
    const response = await GET(SHOP.FEATURED.GET(), opts);

    return formatResponse(response);
  }

  async getShopsInCategory(category, queryParams, opts = {}) {
    const response = await GET(SHOP.LIST.CATEGORY.GET(category, queryParams), opts);

    return formatResponse(response);
  }

  async getFeaturedBrands(opts = {}) {
    const response = await GET(SHOP.FEATURED_BRANDS.GET(), opts);

    return formatResponse(response);
  }

  async toggleAppropriateProducts(shopId: number, data, opts = {}) {
    const response = await PATCH(SHOP.TOGGLE_APPROPRIATE_PRODUCTS.PATCH(shopId), data, opts);

    return formatResponse(response);
  }

  async getNewShopSlug(shopName: string, opts = {}) {
    const response = await GET(SHOP.SLUG.GET(shopName), opts);

    return formatResponse(response);
  }
}
